var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChampion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 125,
    viewBox: "0 0 360 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5712_87851)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5712_87851)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.437 27.1696C171.032 25.768 166.216 23.8522 162.975 24.1866C161.72 24.3116 160.703 25.2117 160.181 26.3117H160.175C160.127 26.4164 160.077 26.5274 160.036 26.6399V26.6461C160.022 26.6665 160.016 26.6883 160.008 26.7086C159.416 28.3603 159.931 30.3058 162.322 30.7855C162.322 30.7855 162.267 30.8199 162.163 30.8699C161.075 31.4418 154.636 34.4592 148.257 30.1245C143.218 26.7024 141.461 21.0848 141.294 17.2236V17.2033C141.231 15.711 141.407 14.4922 141.719 13.7531C142.73 11.3763 149.324 11.9889 151.401 12.1842C151.276 12.1842 151.151 12.1983 151.032 12.2264C151.018 12.2264 151.004 12.2264 150.99 12.2327C150.593 12.317 150.231 12.5045 149.931 12.7827C148.627 13.9468 148.307 16.6158 150.084 19.0347C153.256 23.349 159.137 20.7911 158.93 19.0347C158.714 17.2721 155.745 7.67296 155.745 7.67296C155.745 7.67296 155.397 7.6589 154.782 7.63077C151.27 7.48389 139.155 7.01667 135.809 7.47764C135.426 7.52608 135.155 7.5964 135.028 7.67296C133.62 8.55896 134.15 34.3545 149.818 38.1391C165.488 41.9238 171.845 28.5697 171.44 27.1681L171.437 27.1696ZM152.395 12.3436C152.528 12.392 152.66 12.4545 152.785 12.5311C152.618 12.4405 152.451 12.3702 152.284 12.3155C152.318 12.3295 152.36 12.3295 152.395 12.3436Z",
    fill: "url(#paint0_linear_5712_87851)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M149.814 38.14C134.146 34.3554 133.616 8.55828 135.024 7.67384C135.149 7.59727 135.421 7.52696 135.805 7.47852C133.771 9.78492 135.624 33.2053 149.008 35.8461C162.39 38.4885 167.984 33.135 167.934 29.3988C167.878 25.6704 161.993 24.575 160.473 26.0939C160.334 26.2329 160.235 26.3032 160.18 26.3095C160.704 25.2079 161.721 24.3094 162.974 24.1843C166.215 23.85 171.033 25.7657 171.436 27.1674C171.841 28.569 165.484 41.9231 149.814 38.1384V38.14Z",
    fill: "url(#paint1_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M150.088 19.0352C148.311 16.6162 148.631 13.9473 149.935 12.7832C148.046 15.7318 151.608 19.4336 154.737 18.4148C157.629 17.4804 155.162 8.87977 154.785 7.63281C155.399 7.66094 155.748 7.675 155.748 7.675C155.748 7.675 158.717 17.2725 158.932 19.0367C159.142 20.7931 153.258 23.3511 150.086 19.0367L150.088 19.0352Z",
    fill: "url(#paint2_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M152.397 12.3459C152.359 12.3318 152.322 12.3303 152.284 12.3178C152.047 12.2615 151.762 12.2131 151.4 12.1849C149.323 11.9896 142.729 11.3771 141.718 13.7538C141.404 14.4929 141.23 15.7117 141.293 17.204C141.091 13.921 140.422 11.0208 145.859 10.8473C150.968 10.6801 152.85 12.4021 153.059 12.6178C152.997 12.5756 152.787 12.4506 152.397 12.3459Z",
    fill: "url(#paint3_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M162.165 30.8722C162.269 30.8237 162.324 30.7878 162.324 30.7878C159.933 30.3065 159.417 28.3626 160.01 26.7109C160.016 26.6906 160.024 26.6688 160.038 26.6484C159.953 30.2518 163.272 31.1441 166.234 29.4158C166.024 29.5752 164.302 30.83 162.163 30.8722H162.165Z",
    fill: "url(#paint4_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.291 12.316C149.159 12.0129 148.859 16.8538 153.15 17.7117C157.443 18.5696 156.468 11.305 155.139 8.89545C153.811 6.48591 137.96 7.30159 136.246 8.89545C134.532 10.4893 135.454 30.5219 146.481 35.6067C157.508 40.6914 166.54 36.3333 167.703 30.8188C168.865 25.3044 162.13 24.2481 161.14 27.1545C160.149 30.0594 166.237 29.4141 166.237 29.4141C166.237 29.4141 163.013 33.7581 152.541 32.4377C139.596 30.8048 139.077 14.9756 141.16 12.316C143.243 9.65644 151.891 10.6831 152.289 12.316H152.291Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.376 7.85662C133.907 9.13327 134.791 19.259 138.709 24.4093C142.626 29.5597 144.695 29.0721 144.695 29.0721C144.695 29.0721 138.328 16.4338 141.159 12.321C143.99 8.2082 153.016 11.9069 153.543 12.8304C153.543 12.8304 151.508 12.0428 150.549 13.843C149.589 15.6431 153.189 17.7604 154.774 16.7932C156.358 15.8244 156.187 9.90051 155.041 8.54885C153.894 7.1972 137.649 7.1972 136.374 7.85662H136.376Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M155.745 7.67578C155.745 7.67578 156.746 12.7293 157.076 16.8561C157.407 20.9829 155.723 21.2798 155.723 21.2798C155.723 21.2798 158.671 21.0204 158.931 19.0375C158.931 19.0375 157.352 16.7873 155.746 7.67578H155.745Z",
    fill: "url(#paint5_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M163.344 24.1621C163.344 24.1621 166.085 25.4075 168.23 27.1248C170.375 28.8421 170.255 30.3141 170.255 30.3141C170.255 30.3141 171.505 28.3093 171.436 27.1717C171.436 27.1717 167.307 26.2498 163.344 24.1621Z",
    fill: "url(#paint6_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M152.749 13.2266C150.419 13.2266 153.321 15.472 153.321 15.472C153.321 15.472 155.346 13.2266 152.749 13.2266Z",
    fill: "url(#paint7_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M164.282 26.2734C161.952 26.2734 164.079 28.2548 164.079 28.2548C164.079 28.2548 166.232 26.2734 164.282 26.2734Z",
    fill: "url(#paint8_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M138.236 9.67656C136.094 11.3751 139.116 20.8133 139.116 20.8133C139.116 20.8133 138.174 13.5456 139.363 11.3439C140.552 9.14215 146.89 8.8812 146.89 8.8812C146.89 8.8812 140.038 8.24522 138.236 9.675V9.67656Z",
    fill: "url(#paint9_linear_5712_87851)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.817 38.1423C226.486 34.3577 227.017 8.56061 225.607 7.67618C225.482 7.59961 225.21 7.52929 224.826 7.48085C221.48 7.02144 209.366 7.4871 205.853 7.63399C205.24 7.66211 204.89 7.67618 204.89 7.67618C204.89 7.67618 201.921 17.2737 201.706 19.0379C201.496 20.7943 207.38 23.3523 210.55 19.0379C212.327 16.619 212.006 13.95 210.703 12.7859C210.403 12.5078 210.041 12.3187 209.644 12.2359C209.63 12.2296 209.616 12.2296 209.602 12.2296C209.483 12.2015 209.358 12.1874 209.231 12.1874C211.308 11.9921 217.902 11.3796 218.913 13.7563C219.227 14.4954 219.401 15.7142 219.338 17.2065V17.2268C219.171 21.088 217.415 26.7056 212.375 30.1277C205.997 34.4624 199.557 31.445 198.47 30.8731C198.365 30.8246 198.31 30.7887 198.31 30.7887C200.701 30.3074 201.217 28.3635 200.624 26.7119C200.618 26.6915 200.61 26.6697 200.596 26.6494V26.6431C200.556 26.5322 200.506 26.4197 200.457 26.315H200.449C199.927 25.2133 198.909 24.3148 197.655 24.1898C194.413 23.8554 189.597 25.7712 189.194 27.1728C188.789 28.5745 195.146 41.9285 210.816 38.1439L210.817 38.1423ZM208.35 12.3187C208.183 12.3749 208.015 12.4437 207.848 12.5343C207.973 12.4578 208.106 12.3953 208.239 12.3468C208.273 12.3327 208.316 12.3327 208.35 12.3187Z",
    fill: "url(#paint10_linear_5712_87851)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M210.816 38.14C226.484 34.3554 227.015 8.55828 225.606 7.67384C225.481 7.59727 225.209 7.52696 224.824 7.47852C226.861 9.78492 225.006 33.2053 211.624 35.8461C198.241 38.4885 192.649 33.135 192.697 29.3988C192.752 25.6704 198.638 24.575 200.157 26.0939C200.296 26.2329 200.395 26.3032 200.449 26.3095C199.927 25.2079 198.909 24.3094 197.655 24.1843C194.413 23.85 189.597 25.7657 189.194 27.1674C188.789 28.569 195.146 41.9231 210.816 38.1384V38.14Z",
    fill: "url(#paint11_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M210.555 19.0352C212.331 16.6162 212.011 13.9473 210.708 12.7832C212.597 15.7318 209.034 19.4336 205.904 18.4148C203.012 17.4804 205.479 8.87977 205.856 7.63281C205.243 7.66094 204.893 7.675 204.893 7.675C204.893 7.675 201.924 17.2725 201.709 19.0367C201.499 20.7931 207.382 23.3511 210.553 19.0367L210.555 19.0352Z",
    fill: "url(#paint12_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M208.242 12.3459C208.28 12.3318 208.317 12.3303 208.353 12.3178C208.591 12.2615 208.877 12.2131 209.238 12.1849C211.314 11.9896 217.909 11.3771 218.92 13.7538C219.234 14.4929 219.407 15.7117 219.345 17.204C219.546 13.921 220.215 11.0208 214.779 10.8473C209.669 10.6801 207.788 12.4021 207.578 12.6178C207.641 12.5756 207.85 12.4506 208.241 12.3459H208.242Z",
    fill: "url(#paint13_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M198.471 30.8722C198.367 30.8237 198.312 30.7878 198.312 30.7878C200.703 30.3065 201.218 28.3626 200.626 26.7109C200.62 26.6906 200.612 26.6688 200.598 26.6484C200.682 30.2518 197.365 31.1441 194.402 29.4158C194.612 29.5752 196.332 30.83 198.473 30.8722H198.471Z",
    fill: "url(#paint14_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.347 12.316C211.479 12.0129 211.779 16.8538 207.488 17.7117C203.196 18.5696 204.171 11.305 205.499 8.89545C206.827 6.48591 222.678 7.30159 224.392 8.89545C226.107 10.4893 225.185 30.5219 214.157 35.6067C203.13 40.6914 194.098 36.3333 192.935 30.8188C191.771 25.3044 198.508 24.2481 199.498 27.1545C200.489 30.0594 194.401 29.4141 194.401 29.4141C194.401 29.4141 197.626 33.7581 208.097 32.4377C221.042 30.8048 221.561 14.9756 219.478 12.316C217.395 9.65644 208.748 10.6831 208.349 12.316H208.347Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M224.262 7.85662C226.729 9.13327 225.846 19.259 221.929 24.4093C218.012 29.5597 215.941 29.0721 215.941 29.0721C215.941 29.0721 222.309 16.4338 219.477 12.321C216.646 8.2082 207.622 11.9069 207.094 12.8304C207.094 12.8304 209.128 12.0428 210.088 13.843C211.045 15.6431 207.445 17.7604 205.861 16.7932C204.276 15.8244 204.448 9.90051 205.594 8.54885C206.74 7.1972 222.984 7.1972 224.262 7.85662Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M204.889 7.67578C204.889 7.67578 203.888 12.7293 203.558 16.8561C203.228 20.9829 204.911 21.2798 204.911 21.2798C204.911 21.2798 201.963 21.0204 201.703 19.0375C201.703 19.0375 203.281 16.7873 204.888 7.67578H204.889Z",
    fill: "url(#paint15_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M197.287 24.1621C197.287 24.1621 194.546 25.4075 192.401 27.1248C190.255 28.8421 190.375 30.3141 190.375 30.3141C190.375 30.3141 189.125 28.3093 189.194 27.1717C189.194 27.1717 193.324 26.2498 197.287 24.1621Z",
    fill: "url(#paint16_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M207.886 13.2266C210.215 13.2266 207.314 15.472 207.314 15.472C207.314 15.472 205.289 13.2266 207.886 13.2266Z",
    fill: "url(#paint17_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M196.352 26.2734C198.68 26.2734 196.555 28.2548 196.555 28.2548C196.555 28.2548 194.402 26.2734 196.352 26.2734Z",
    fill: "url(#paint18_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M222.435 9.68601C224.444 11.2439 221.555 20.8227 221.555 20.8227C221.555 20.8227 222.794 13.555 221.605 11.3533C220.416 9.1516 214.578 8.89221 214.578 8.89221C214.578 8.89221 220.618 8.27498 222.435 9.68601Z",
    fill: "url(#paint19_linear_5712_87851)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.482 29.3583C181.25 33.443 182.728 43.1796 189.448 45H171.199C172.168 44.7359 173.026 44.3171 173.772 43.7734C179.208 39.8278 179.075 29.5333 175.542 27.7488C173.047 26.494 157.35 29.338 155.664 6.62236C156.814 6.2739 159.038 6.02232 161.7 5.8348C169.256 5.29883 180.325 5.29883 180.325 5.29883C180.325 5.29883 196.42 5.29883 203.035 6.23327C203.842 6.35203 204.505 6.47703 204.986 6.62392C203.3 29.3395 187.687 26.6769 185.107 27.7504C184.438 28.0285 183.894 28.5942 183.483 29.3599L183.482 29.3583Z",
    fill: "url(#paint20_linear_5712_87851)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M204.985 6.62115C203.299 29.3368 187.685 26.6741 185.105 27.7476C184.436 28.0257 183.893 28.5914 183.482 29.3571L182.994 29.1618C182.994 29.1618 178.944 29.7759 178.505 34.6121C178.066 39.4562 180.324 43.1705 180.324 43.1705L173.772 43.7706C179.208 39.825 179.075 29.5305 175.542 27.746C173.047 26.4913 157.35 29.3352 155.664 6.61959C156.814 6.27112 159.038 6.01954 161.7 5.83203C157.33 13.22 172.292 24.9443 189.688 20.3018C201.311 17.2 203.585 9.25414 203.033 6.22893C203.841 6.34769 204.503 6.4727 204.985 6.61959V6.62115Z",
    fill: "url(#paint21_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.828 6.2709C157.896 8.9789 167.766 23.3018 182.381 23.1064C196.996 22.9111 200.518 13.5777 199.813 9.35236C199.108 5.12551 169.438 5.03801 165.828 6.2709Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.129 5.83433C167.854 8.99705 171.551 19.0337 183.702 20.4416C195.851 21.8495 199.192 9.78773 195.323 7.63133C191.454 5.47493 178.129 5.83277 178.129 5.83277V5.83433Z",
    fill: "#FFFB25"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185.453 5.58456C183.022 7.70658 187.802 8.17223 189.505 7.05028C191.858 5.50018 187.416 5.23297 185.453 5.58456Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M181.452 29.7379C177.363 29.1566 177.961 41.9825 179.467 43.0545C180.974 44.1248 183.615 43.7967 183.791 42.992C183.968 42.1872 181.844 37.0978 181.452 29.7379Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.465 28.7577C177.89 30.3891 179.474 38.5771 180.971 39.1943C182.468 39.8116 182.471 29.5843 181.71 29.0624C180.537 28.2561 179.465 28.7577 179.465 28.7577Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M180.796 31.3496C179.736 31.3418 180.871 37.325 180.871 37.325C180.871 37.325 181.943 31.359 180.796 31.3496Z",
    fill: "url(#paint22_linear_5712_87851)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M254.908 49.8585C252.748 51.5901 247.99 53.0259 247.697 53.1105C247.718 53.1105 247.758 53.106 247.813 53.0959C248.447 52.9898 251.283 52.5315 253.1 52.3859C253.15 52.3813 253.18 52.3757 253.19 52.3757C253.98 52.3102 254.565 52.3102 254.67 52.4265C255.058 52.8396 255.284 63.7302 246.302 65.8546C244.953 66.1774 243.352 65.9449 241.605 65.3308C231.726 61.8417 217.195 45.8852 217.195 45.8852C232.602 41.1668 249.187 12.281 249.993 12.0045C250.799 11.7223 256.645 24.8242 256.016 28.5097C255.406 32.08 247.572 37.6382 247.083 37.9859C247.315 37.8707 249.132 36.9237 251.162 35.9416C251.172 35.9371 251.178 35.9315 251.188 35.927C253.76 34.6785 256.66 33.3691 257.069 33.5858C257.109 33.6107 257.15 33.6716 257.179 33.7721V33.7766C257.744 35.5285 257.013 48.1721 254.909 49.8585H254.908Z",
    fill: "url(#paint23_linear_5712_87851)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M256.016 28.5097C255.407 32.08 247.573 37.6382 247.084 37.9859C247.316 37.8707 249.133 36.9237 251.162 35.9416C246.384 38.6203 238.942 43.3284 238.031 43.9019C239.295 42.9605 253.362 32.4017 254.097 26.0929C254.868 19.4816 249.994 12.0045 249.994 12.0045C250.8 11.7223 256.646 24.8242 256.016 28.5097Z",
    fill: "url(#paint24_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M253.104 52.3848C252.439 52.4649 248.582 52.9943 247.816 53.0948C248.451 52.9887 251.286 52.5304 253.104 52.3848Z",
    fill: "url(#paint25_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M254.67 52.4269C255.058 52.8401 255.284 63.7306 246.302 65.855C244.953 66.1779 243.352 65.9453 241.605 65.3313L242.013 64.47C242.013 64.47 247.098 64.2183 251.106 60.8048C255.114 57.3914 253.378 52.3615 253.191 52.3761C253.982 52.3107 254.566 52.3107 254.671 52.4269H254.67Z",
    fill: "url(#paint26_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M254.909 49.8589C252.748 51.5905 247.991 53.0263 247.698 53.1109C247.688 53.1155 247.684 53.1155 247.684 53.1155C247.684 53.1155 250.135 52.4867 253.586 48.7324C256.519 45.5413 257.069 33.751 257.069 33.584L257.18 33.7702V33.7747C257.745 35.5266 257.014 48.1702 254.91 49.8566L254.909 49.8589Z",
    fill: "url(#paint27_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M224.552 43.9024C224.552 43.9024 235.807 32.4937 241.377 24.4386C246.946 16.3836 249.104 14.6125 249.867 14.5166C250.63 14.4206 254.455 21.6686 253.101 27.9514C251.748 34.2343 239.468 42.5636 235.175 43.9949C230.882 45.4262 224.551 43.9024 224.551 43.9024H224.552Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M235.168 46.4733C235.168 46.4733 253.204 34.2632 255.589 34.5499C257.974 34.8355 256.307 46.1505 252.059 49.6226C247.812 53.0948 237.654 53.2393 236.413 52.3848C235.172 51.5303 235.168 46.4733 235.168 46.4733Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M233.268 56.4263C233.268 56.4263 249.907 52.2024 252.524 52.7408C254.247 53.0952 254.829 58.4005 249.2 61.7395C243.572 65.0785 232.505 58.0766 233.268 56.4263Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M229.212 39.0017C226.668 45.4347 244.464 38.75 250.456 31.213C256.448 23.6761 250.785 15.051 249.484 15.3761C248.182 15.7023 234.715 32.8419 229.212 39.0017Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M239.559 43.6142C236.542 45.4259 246.042 49.485 251.389 46.8572C256.736 44.2293 256.665 34.7136 255.586 34.5511C254.508 34.3885 240.512 43.0419 239.559 43.6142Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M251.392 52.827C250.079 53.0629 251.739 55.1297 251.739 55.1297C251.739 55.1297 252.411 53.8858 252.475 53.2198C252.538 52.5538 251.392 52.827 251.392 52.827Z",
    fill: "url(#paint28_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M241.736 41.1315C241.521 41.4657 247.75 37.5781 251.228 34.6681C254.707 31.7581 255.453 29.9723 255.453 29.9723C255.453 29.9723 254.14 28.0974 253.826 28.0861C253.514 28.0748 253.23 28.6347 251.299 31.3777C249.366 34.1206 241.735 41.1327 241.735 41.1327L241.736 41.1315Z",
    fill: "url(#paint29_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M249.656 52.3341C249.656 52.3341 252.518 50.0551 253.4 49.4828C254.283 48.9105 255.043 49.739 255.043 49.739C255.043 49.739 252.599 51.2742 249.656 52.3341Z",
    fill: "url(#paint30_linear_5712_87851)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M106.177 49.9907C108.32 51.7081 113.039 53.1322 113.329 53.2162C113.309 53.2162 113.268 53.2117 113.213 53.2016C112.584 53.0964 109.773 52.6419 107.969 52.4974C107.919 52.493 107.889 52.4874 107.88 52.4874C107.096 52.4224 106.516 52.4224 106.412 52.5377C106.027 52.9475 105.803 63.7491 114.711 65.8562C116.05 66.1764 117.638 65.9457 119.371 65.3367C129.17 61.8761 143.582 46.0498 143.582 46.0498C128.301 41.37 111.85 12.7202 111.052 12.4459C110.252 12.166 104.455 25.1608 105.079 28.8162C105.683 32.3574 113.453 37.8702 113.938 38.215C113.708 38.1009 111.905 37.1615 109.893 36.1875C109.883 36.183 109.877 36.1774 109.867 36.1729C107.316 34.9347 104.439 33.636 104.034 33.851C103.994 33.8756 103.955 33.936 103.924 34.0357V34.0402C103.365 35.7777 104.089 48.3181 106.177 49.9907Z",
    fill: "url(#paint31_linear_5712_87851)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M105.082 28.8162C105.687 32.3574 113.456 37.8702 113.941 38.215C113.712 38.1009 111.908 37.1615 109.896 36.1875C114.635 38.8442 122.017 43.514 122.92 44.0827C121.667 43.149 107.714 32.6765 106.985 26.4192C106.221 19.8619 111.055 12.4459 111.055 12.4459C110.256 12.166 104.458 25.1608 105.082 28.8162Z",
    fill: "url(#paint32_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M107.969 52.4961C108.628 52.5756 112.454 53.1007 113.213 53.2003C112.584 53.0951 109.772 52.6405 107.969 52.4961Z",
    fill: "url(#paint33_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M106.414 52.5375C106.029 52.9472 105.805 63.7489 114.713 65.8559C116.052 66.1761 117.64 65.9455 119.373 65.3364L118.969 64.4822C118.969 64.4822 113.925 64.2325 109.95 60.8469C105.974 57.4614 107.697 52.4725 107.882 52.4871C107.098 52.4222 106.518 52.4222 106.414 52.5375Z",
    fill: "url(#paint34_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M106.177 49.9916C108.32 51.709 113.039 53.1331 113.329 53.2171C113.339 53.2216 113.343 53.2216 113.343 53.2216C113.343 53.2216 110.912 52.598 107.489 48.8743C104.58 45.7092 104.034 34.0153 104.034 33.8496L103.924 34.0343V34.0388C103.365 35.7764 104.089 48.3167 106.177 49.9894V49.9916Z",
    fill: "url(#paint35_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M136.285 44.0823C136.285 44.0823 125.122 32.7668 119.598 24.7775C114.074 16.7883 111.933 15.0316 111.176 14.9365C110.419 14.8413 106.626 22.0301 107.969 28.2616C109.311 34.4932 121.49 42.7545 125.747 44.1741C130.005 45.5937 136.285 44.0823 136.285 44.0823Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M125.753 46.6337C125.753 46.6337 107.865 34.5233 105.499 34.8077C103.133 35.0909 104.787 46.3135 109 49.7573C113.213 53.2011 123.288 53.3444 124.518 52.4969C125.749 51.6494 125.753 46.6337 125.753 46.6337Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M127.644 56.5052C127.644 56.5052 111.139 52.3157 108.545 52.8498C106.836 53.2013 106.259 58.4633 111.842 61.775C117.425 65.0867 128.4 58.142 127.644 56.5052Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M131.667 39.2208C134.19 45.6012 116.539 38.9711 110.597 31.4957C104.653 24.0204 110.27 15.4657 111.561 15.7881C112.853 16.1117 126.209 33.1113 131.667 39.2208Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M121.395 43.796C124.387 45.5929 114.965 49.6189 109.662 47.0125C104.359 44.4061 104.429 34.9681 105.498 34.8069C106.568 34.6457 120.449 43.2283 121.395 43.796Z",
    fill: "#FFFB25"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M124.896 31.2731C116.569 26.3526 114.596 34.2713 115.083 36.0671C115.57 37.8629 116.726 38.7776 116.726 38.7776C116.726 38.7776 110.279 33.7294 107.684 28.6533C107.684 28.6533 108.585 30.8947 110.59 31.2093C112.595 31.525 116.251 29.6038 117.326 26.478C118.402 23.3532 116.127 19.6016 116.127 19.6016C116.127 19.6016 121.048 27.6132 124.896 31.272V31.2731Z",
    fill: "url(#paint36_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M115.93 40.0359C110.469 38.2826 108.037 47.7396 109.496 50.8308C109.496 50.8308 107.394 49.1973 106.782 47.8684C106.17 46.5383 105.637 44.925 105.637 44.925C105.637 44.925 106.54 46.9839 107.013 47.2672C107.486 47.5504 110.041 42.3343 110.262 39.7548C110.482 37.1742 109.37 36.0625 109.37 36.0625C109.37 36.0625 113.408 38.4853 115.931 40.037L115.93 40.0359Z",
    fill: "url(#paint37_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M109.67 52.9339C110.971 53.1679 109.326 55.2179 109.326 55.2179C109.326 55.2179 108.659 53.9841 108.596 53.3235C108.534 52.663 109.67 52.9339 109.67 52.9339Z",
    fill: "url(#paint38_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M119.242 41.3355C119.454 41.6669 113.277 37.8111 109.827 34.9249C106.377 32.0386 105.637 30.2675 105.637 30.2675C105.637 30.2675 106.94 28.4078 107.249 28.3966C107.559 28.3855 107.84 28.9408 109.757 31.6613C111.673 34.3819 119.243 41.3367 119.243 41.3367L119.242 41.3355Z",
    fill: "url(#paint39_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M111.389 52.4439C111.389 52.4439 108.551 50.1835 107.676 49.6159C106.8 49.0483 106.047 49.87 106.047 49.87C106.047 49.87 108.471 51.3926 111.389 52.4439Z",
    fill: "url(#paint40_linear_5712_87851)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M350.053 89.2001C350.053 89.2001 348.594 94.4103 340.779 96.2855C332.964 98.1607 329.228 96.7527 329.228 96.7527L335.06 108.588L336.5 111.816C336.5 111.816 321.085 109.571 308.737 103.839C296.39 98.1089 294.577 91.9605 294.415 85.7604C294.254 79.5614 306.359 61.5169 306.359 61.5169C306.359 61.5169 296.623 58.6542 287.077 59.5998C287.077 59.5998 286.383 72.476 285.337 74.3993C284.061 76.748 274.926 81.8016 249.814 78.0499C224.702 74.2982 215.859 62.1716 215.859 62.1716L263.01 61.1729L300.107 49.5L314.091 58.6061L307.238 79.8659L328.683 91.3281L350.054 89.2001H350.053Z",
    fill: "#F7C843"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M314.849 70.843C313.865 76.3429 329.365 84.9657 350.28 88.6607C350.28 88.6607 345.605 98.7617 328.381 95.3121C328.381 95.3121 336.747 103.688 336.501 111.818C336.501 111.818 306.199 103.322 297.932 94.4269C289.137 84.9645 303.9 74.21 314.849 70.8418V70.843Z",
    fill: "url(#paint41_linear_5712_87851)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M317.739 76.0919C304.52 78.5737 306.848 96.9474 310.581 101.775C310.581 101.775 298.501 97.5219 296.926 88.9336C295.35 80.3453 303.906 75.2757 314.893 72.0801C314.893 72.0801 316.645 75.1906 317.739 76.0919Z",
    fill: "#EDA900"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M211.457 47.8664L214 47.8661C214 47.8661 228.012 41.2359 249.84 51.2136C271.667 61.1914 287.662 48.7972 287.662 48.7972C287.662 48.7972 286.495 71.6314 280.819 75.3264C275.142 79.0213 225.554 82.5819 211.458 47.8676L211.457 47.8664Z",
    fill: "url(#paint42_linear_5712_87851)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M272.736 54.6485C274.683 54.9197 279.407 70.3579 274.683 73.7964C269.959 77.2349 263.438 76.8034 263.438 76.8034C263.438 76.8034 277.458 77.6849 281.768 72.7731C286.078 67.8613 284.946 51.3086 284.946 51.3086C280.361 52.8361 276.105 54.0998 272.736 54.6497V54.6485Z",
    fill: "#F7D543"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M268.407 67.2422C264.822 73.3635 244.398 77.845 234.082 68.4664L268.407 67.2422Z",
    fill: "url(#paint43_linear_5712_87851)"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M295.066 84.0273C295.442 77.1737 313.435 49.3672 313.435 49.3672C313.435 49.3672 316.664 65.9963 314.82 69.8762C312.974 73.7561 300.042 74.6216 295.066 84.0273Z",
    fill: "url(#paint44_linear_5712_87851)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M285.26 72.3578C286.769 66.6409 288.613 42.7143 288.613 42.7143L283.538 39.4805C283.538 39.4805 279.063 57.1255 277.449 62.761C277.602 65.8395 285.32 70.0375 285.26 72.3578Z",
    fill: "url(#paint45_linear_5712_87851)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M323.585 48.1081C323.585 48.1081 319.153 58.1167 318.416 66.7678C318.416 66.7678 315.095 61.4393 298.855 59.2226C283.006 57.0613 277.084 60.6355 276.809 60.8118C276.88 60.7514 276.957 60.686 277.023 60.6083C280.241 57.1982 282.803 34.0298 282.803 34.0298C282.803 34.0298 285.333 32.9683 289.166 32.0671C298.878 29.7899 316.971 28.5312 323.587 48.1081H323.585Z",
    fill: "#EDA900"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M209.169 49.0059C213.229 75.3588 260.471 82.2567 277.693 76.8358C294.916 71.416 277.693 66.7582 278.923 62.9288C280.154 59.0983 300.699 56.5117 312.263 64.1494C323.827 71.7859 296.147 72.4023 294.916 84.9666C293.686 97.5309 309.372 105.352 336.498 111.82C336.498 111.82 313.062 105.354 301.559 96.0527C294.264 90.1546 294.67 79.9167 306.111 75.7286C317.552 71.5405 318.414 70.3767 318.414 66.7705C318.414 63.1643 303.281 56.0197 287.043 57.6213C270.804 59.2228 277.324 64.465 281.63 68.7073C285.935 72.9497 275.971 80.4087 247.306 74.8668C218.641 69.3238 211.454 47.8691 211.454 47.8691L209.168 49.0071L209.169 49.0059Z",
    fill: "url(#paint46_linear_5712_87851)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M328.383 95.3116C328.383 95.3116 343.514 97.8982 350.281 88.6602C350.281 88.6602 348.984 97.5567 329.642 96.6961L328.384 95.3128L328.383 95.3116Z",
    fill: "url(#paint47_linear_5712_87851)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2,
    d: "M288.218 57.3356C288.218 57.3356 280.128 57.8251 277.027 60.6077C280.245 57.1975 282.807 34.0292 282.807 34.0292C282.807 34.0292 285.337 32.9676 289.17 32.0664L289.176 32.0713C282.247 41.0356 288.219 57.3356 288.219 57.3356H288.218Z",
    fill: "url(#paint48_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M303.157 66.2637C309.555 63.7412 315.038 67.9417 315.038 67.9417C315.038 67.9417 315.432 65.4389 311.163 63.4663C306.893 61.4937 306.102 61.2188 306.102 61.2188L303.156 66.2637H303.157Z",
    fill: "url(#paint49_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M279.713 65.0361C281.004 60.6853 286.513 64.5799 286.513 64.5799L287.077 59.6016C287.077 59.6016 280.918 60.3364 279.556 62.0562C278.192 63.7761 279.715 65.0361 279.715 65.0361H279.713Z",
    fill: "url(#paint50_linear_5712_87851)"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M296.738 79.8422C296.738 79.8422 299.207 69.8608 304.624 66.7662C310.042 63.6729 314.217 69.3011 314.217 69.3011C314.217 69.3011 310.563 72.3204 305.249 74.092C299.935 75.8637 296.738 79.8422 296.738 79.8422Z",
    fill: "url(#paint51_linear_5712_87851)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M280.799 62.3195C277.951 64.9234 281.404 66.4867 283.091 68.1881C284.777 69.8895 285.083 70.4023 285.083 70.4023C285.083 70.4023 287.12 67.2153 286.216 63.3256C285.312 59.4358 280.797 62.3195 280.797 62.3195H280.799Z",
    fill: "url(#paint52_linear_5712_87851)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.64
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M298.633 77.3227C298.633 77.3227 301.715 69.5728 304.938 67.5275C308.159 65.4833 312.032 70.8414 312.032 70.8414C312.032 70.8414 309.783 73.1543 305.25 74.0926C300.716 75.0308 298.633 77.3227 298.633 77.3227Z",
    fill: "#74FB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.64
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M279.884 64.581C282.537 61.5887 284.757 65.4575 285.177 67.424C285.597 69.3904 285.086 69.9773 285.086 69.9773C285.086 69.9773 284.413 69.0045 283.093 68.1884C281.773 67.3722 279.75 65.5241 279.885 64.581H279.884Z",
    fill: "#74FB25"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2,
    d: "M307.238 96.7547C307.75 82.2906 319.176 78.7251 325.81 81.5952C332.443 84.4666 342.738 88.5178 344.545 88.2072C346.353 87.8965 342.622 94.0301 336.231 94.7242C329.84 95.4183 326.575 94.2532 326.575 94.2532C326.575 94.2532 333.157 100.817 331.715 105.353C330.273 109.889 312.145 105.177 307.238 96.7547Z",
    fill: "url(#paint53_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.64
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M256.234 76.0917C256.234 76.0917 263.902 69.9248 268.705 68.1532C273.508 66.3815 278.987 73.3091 278.987 73.3091C278.987 73.3091 278.376 75.3162 271.103 76.6182C263.83 77.9201 256.234 76.0917 256.234 76.0917Z",
    fill: "#74FB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.64
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M259.685 76.2291C259.685 76.2291 261.121 73.2591 266.553 71.4357C271.985 69.6123 275.843 75.3945 275.843 75.3945C275.843 75.3945 274.262 76.1712 269.545 76.6693C264.318 77.2204 259.684 76.2291 259.684 76.2291H259.685Z",
    fill: "#74FB25"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80859 89.2001C9.80859 89.2001 11.2671 94.4103 19.0823 96.2855C26.8976 98.1607 30.6332 96.7527 30.6332 96.7527L24.8017 108.588L23.3617 111.816C23.3617 111.816 38.7764 109.571 51.1238 103.839C63.4711 98.1089 65.2847 91.9605 65.4462 85.7604C65.6077 79.5614 53.5032 61.5169 53.5032 61.5169C53.5032 61.5169 63.2406 58.6542 72.7855 59.5998C72.7855 59.5998 73.4784 72.476 74.5251 74.3993C75.8024 76.748 84.9368 81.8016 110.049 78.0499C135.161 74.2982 144.004 62.1716 144.004 62.1716L96.8527 61.1729L59.7552 49.5L45.7731 58.6061L52.6254 79.8659L31.1806 91.3281L9.80859 89.2001Z",
    fill: "#F7C843"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0166 70.843C46.0004 76.3429 30.5006 84.9657 9.58594 88.6607C9.58594 88.6607 14.261 98.7617 31.4844 95.3121C31.4844 95.3121 23.1181 103.688 23.3646 111.818C23.3646 111.818 53.6665 103.322 61.9342 94.4269C70.7284 84.9645 55.9658 74.21 45.0166 70.8418V70.843Z",
    fill: "url(#paint54_linear_5712_87851)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M42.125 76.0919C55.344 78.5737 53.0163 96.9474 49.2831 101.775C49.2831 101.775 61.3629 97.5219 62.9385 88.9336C64.5142 80.3453 55.9592 75.2757 44.9717 72.0801C44.9717 72.0801 43.2198 75.1906 42.1262 76.0919H42.125Z",
    fill: "#EDA900"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M148.406 47.8687C148.406 47.8687 131.851 41.237 110.023 51.2148C88.1949 61.1925 72.2031 48.7983 72.2031 48.7983C72.2031 48.7983 73.3694 71.6326 79.0469 75.3275C84.7231 79.0225 134.312 82.5831 148.406 47.8687Z",
    fill: "url(#paint55_linear_5712_87851)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1298 54.6485C85.1831 54.9197 80.4587 70.3579 85.1831 73.7964C89.9063 77.2349 96.4282 76.8034 96.4282 76.8034C96.4282 76.8034 82.4079 77.6849 78.0977 72.7731C73.7876 67.8613 74.9193 51.3086 74.9193 51.3086C79.5044 52.8361 83.7604 54.0998 87.1298 54.6497V54.6485Z",
    fill: "#F7D543"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M91.4609 67.2422C95.0474 73.3635 115.47 77.845 125.786 68.4664L91.4609 67.2422Z",
    fill: "url(#paint56_linear_5712_87851)"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7989 84.0273C64.4229 77.1737 46.4302 49.3672 46.4302 49.3672C46.4302 49.3672 43.2013 65.9963 45.0457 69.8762C46.8913 73.7561 59.823 74.6216 64.7977 84.0273H64.7989Z",
    fill: "url(#paint57_linear_5712_87851)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6034 72.3578C73.0956 66.6409 71.25 42.7143 71.25 42.7143L76.3246 39.4805C76.3246 39.4805 80.7999 57.1255 82.4138 62.761C82.2609 65.8395 74.543 70.0375 74.6034 72.3578Z",
    fill: "url(#paint58_linear_5712_87851)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2773 48.1081C36.2773 48.1081 40.7096 58.1167 41.4468 66.7678C41.4468 66.7678 44.7682 61.4393 61.0078 59.2226C76.8565 57.0613 82.7793 60.6355 83.0554 60.8118C82.9839 60.7514 82.9063 60.686 82.8409 60.6083C79.6231 57.1982 77.0611 34.0298 77.0611 34.0298C77.0611 34.0298 74.5313 32.9683 70.6982 32.0671C60.9868 29.7899 42.893 28.5312 36.2786 48.1081H36.2773Z",
    fill: "#EDA900"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M150.692 49.0059C146.632 75.3588 99.3915 82.2567 82.1681 76.8358C64.9448 71.416 82.1681 66.7582 80.9377 62.9288C79.7073 59.0983 59.1625 56.5117 47.5981 64.1494C36.0336 71.7859 63.7143 72.4023 64.9448 84.9666C66.1752 97.5309 50.4892 105.352 23.3633 111.82C23.3633 111.82 46.7992 105.354 58.302 96.0527C65.597 90.1546 65.1913 79.9167 53.7502 75.7286C42.309 71.5405 41.4472 70.3767 41.4472 66.7705C41.4472 63.1643 56.5796 56.0197 72.818 57.6213C89.0563 59.2228 82.5368 64.465 78.2303 68.7073C73.9251 72.9497 83.8893 80.4087 112.554 74.8668C141.218 69.3238 148.406 47.8691 148.406 47.8691L150.692 49.0071V49.0059Z",
    fill: "url(#paint59_linear_5712_87851)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4844 95.3116C31.4844 95.3116 16.352 97.8982 9.58594 88.6602C9.58594 88.6602 10.8829 97.5567 30.2257 96.6961L31.4844 95.3128V95.3116Z",
    fill: "url(#paint60_linear_5712_87851)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2,
    d: "M71.6481 57.3356C71.6481 57.3356 79.7383 57.8251 82.839 60.6077C79.6212 57.1975 77.0593 34.0292 77.0593 34.0292C77.0593 34.0292 74.5294 32.9676 70.6963 32.0664L70.6914 32.0713C77.6202 41.0356 71.6481 57.3356 71.6481 57.3356Z",
    fill: "url(#paint61_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M56.7062 66.2637C50.31 63.7412 44.8261 67.9417 44.8261 67.9417C44.8261 67.9417 44.4303 65.4389 48.701 63.4663C52.9705 61.4937 53.7608 61.2188 53.7608 61.2188L56.7062 66.2637Z",
    fill: "url(#paint62_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M80.1492 65.0361C78.8583 60.6853 73.3498 64.5799 73.3498 64.5799L72.7852 59.6016C72.7852 59.6016 78.9434 60.3364 80.307 62.0562C81.6706 63.7761 80.1479 65.0361 80.1479 65.0361H80.1492Z",
    fill: "url(#paint63_linear_5712_87851)"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M63.127 79.8422C63.127 79.8422 60.66 69.8608 55.2415 66.7662C49.823 63.6729 45.6484 69.3011 45.6484 69.3011C45.6484 69.3011 49.3027 72.3204 54.6164 74.092C59.9302 75.8637 63.127 79.8422 63.127 79.8422Z",
    fill: "url(#paint64_linear_5712_87851)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0704 62.3195C81.9184 64.9234 78.4651 66.4867 76.7785 68.1881C75.0919 69.8895 74.7861 70.4023 74.7861 70.4023C74.7861 70.4023 72.7494 67.2153 73.6531 63.3256C74.5568 59.4358 79.0716 62.3195 79.0716 62.3195H79.0704Z",
    fill: "url(#paint65_linear_5712_87851)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.64
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2337 77.3227C61.2337 77.3227 58.1515 69.5728 54.93 67.5275C51.7084 65.4833 47.8359 70.8414 47.8359 70.8414C47.8359 70.8414 50.0847 73.1543 54.618 74.0926C59.1501 75.0308 61.2349 77.3227 61.2349 77.3227H61.2337Z",
    fill: "#74FB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.64
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9859 64.581C77.3328 61.5887 75.1136 65.4575 74.6932 67.424C74.2727 69.3904 74.7844 69.9773 74.7844 69.9773C74.7844 69.9773 75.4575 69.0045 76.7767 68.1884C78.0971 67.3722 80.1203 65.5241 79.9847 64.581H79.9859Z",
    fill: "#74FB25"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2,
    d: "M52.6261 96.7547C52.1145 82.2906 40.6869 78.7251 34.054 81.5952C27.421 84.4666 17.1265 88.5178 15.3191 88.2072C13.5116 87.8965 17.2423 94.0301 23.6336 94.7242C30.0249 95.4183 33.2896 94.2532 33.2896 94.2532C33.2896 94.2532 26.7072 100.817 28.1497 105.353C29.5922 109.889 47.7192 105.177 52.6261 96.7547Z",
    fill: "url(#paint66_linear_5712_87851)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.64
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M103.633 76.0917C103.633 76.0917 95.9657 69.9248 91.1624 68.1532C86.3591 66.3815 80.8789 73.3091 80.8789 73.3091C80.8789 73.3091 81.4904 75.3162 88.7632 76.6182C96.036 77.9201 103.633 76.0917 103.633 76.0917Z",
    fill: "#74FB25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.64
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M100.182 76.2291C100.182 76.2291 98.7453 73.2591 93.3132 71.4357C87.8811 69.6123 84.0234 75.3945 84.0234 75.3945C84.0234 75.3945 85.604 76.1712 90.321 76.6693C95.5497 77.2204 100.183 76.2291 100.183 76.2291H100.182Z",
    fill: "#74FB25"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M268.511 55.6547C262.996 49.3781 96.6713 49.3781 91.1554 55.6547C88.8437 58.2857 90.0778 84.3642 94.5902 87.5032C99.1026 90.6421 260.893 90.3807 265.405 87.2418C269.918 84.1029 270.822 58.2857 268.511 55.6547Z",
    fill: "#911408"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M265.629 84.9554C261.119 88.0907 98.5509 88.0907 94.0422 84.9554C90.33 82.3763 89.2081 61.6994 90.2141 53.3022C90.4286 51.4825 90.748 50.1892 91.1597 49.722C96.6695 43.4416 263 43.4416 268.51 49.722C268.922 50.1954 269.241 51.4874 269.462 53.3183C270.457 61.7216 269.336 82.3763 265.629 84.9554Z",
    fill: "url(#paint67_linear_5712_87851)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M198.348 50.0829C183.474 49.9772 167.334 49.818 147.51 50.7208C145.625 50.9524 148.932 51.4741 158.015 51.093C173.912 50.4266 224.848 52.0438 226.856 51.9991C228.836 51.9544 209.896 50.165 198.349 50.0829H198.348Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M143.221 51.0248C137.995 51.3237 137.921 52.1511 141.359 51.9759C144.797 51.8016 146.547 50.834 143.221 51.0248Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M132.621 70.8379H136.723C136.668 72.0254 136.348 73.0723 135.762 73.9785C135.176 74.8848 134.363 75.5918 133.324 76.0996C132.293 76.5996 131.074 76.8496 129.668 76.8496C128.527 76.8496 127.508 76.6582 126.609 76.2754C125.719 75.8926 124.961 75.3418 124.336 74.623C123.719 73.9043 123.246 73.0332 122.918 72.0098C122.598 70.9863 122.438 69.834 122.438 68.5527V67.627C122.438 66.3457 122.605 65.1934 122.941 64.1699C123.285 63.1387 123.77 62.2637 124.395 61.5449C125.027 60.8184 125.785 60.2637 126.668 59.8809C127.551 59.498 128.531 59.3066 129.609 59.3066C131.094 59.3066 132.348 59.5723 133.371 60.1035C134.395 60.6348 135.188 61.3652 135.75 62.2949C136.312 63.2168 136.645 64.2676 136.746 65.4473H132.645C132.629 64.8066 132.52 64.2715 132.316 63.8418C132.113 63.4043 131.793 63.0762 131.355 62.8574C130.918 62.6387 130.336 62.5293 129.609 62.5293C129.102 62.5293 128.66 62.623 128.285 62.8105C127.91 62.998 127.598 63.2949 127.348 63.7012C127.098 64.1074 126.91 64.6348 126.785 65.2832C126.668 65.9238 126.609 66.6973 126.609 67.6035V68.5527C126.609 69.459 126.664 70.2324 126.773 70.873C126.883 71.5137 127.059 72.0371 127.301 72.4434C127.543 72.8496 127.855 73.1504 128.238 73.3457C128.629 73.5332 129.105 73.627 129.668 73.627C130.293 73.627 130.82 73.5293 131.25 73.334C131.68 73.1309 132.012 72.8262 132.246 72.4199C132.48 72.0059 132.605 71.4785 132.621 70.8379ZM142.348 58.6152V76.6152H138.398V58.6152H142.348ZM141.879 69.8418L140.953 69.8652C140.953 68.9746 141.062 68.1543 141.281 67.4043C141.5 66.6543 141.812 66.002 142.219 65.4473C142.625 64.8926 143.113 64.4629 143.684 64.1582C144.254 63.8535 144.887 63.7012 145.582 63.7012C146.207 63.7012 146.777 63.791 147.293 63.9707C147.816 64.1504 148.266 64.4395 148.641 64.8379C149.023 65.2363 149.316 65.7559 149.52 66.3965C149.73 67.0371 149.836 67.8184 149.836 68.7402V76.6152H145.863V68.7168C145.863 68.2012 145.789 67.8027 145.641 67.5215C145.5 67.2324 145.297 67.0332 145.031 66.9238C144.766 66.8066 144.441 66.748 144.059 66.748C143.598 66.748 143.223 66.8262 142.934 66.9824C142.645 67.1387 142.422 67.3574 142.266 67.6387C142.117 67.9121 142.016 68.2363 141.961 68.6113C141.906 68.9863 141.879 69.3965 141.879 69.8418ZM158.613 73.4277V68.2012C158.613 67.8418 158.562 67.5332 158.461 67.2754C158.359 67.0176 158.199 66.8184 157.98 66.6777C157.762 66.5293 157.469 66.4551 157.102 66.4551C156.805 66.4551 156.551 66.5059 156.34 66.6074C156.129 66.709 155.969 66.8613 155.859 67.0645C155.75 67.2676 155.695 67.5254 155.695 67.8379H151.746C151.746 67.252 151.875 66.709 152.133 66.209C152.398 65.7012 152.773 65.2598 153.258 64.8848C153.75 64.5098 154.336 64.2207 155.016 64.0176C155.703 63.8066 156.469 63.7012 157.312 63.7012C158.32 63.7012 159.219 63.8691 160.008 64.2051C160.805 64.541 161.434 65.0449 161.895 65.7168C162.355 66.3809 162.586 67.2168 162.586 68.2246V73.416C162.586 74.2441 162.633 74.873 162.727 75.3027C162.82 75.7246 162.953 76.0957 163.125 76.416V76.6152H159.164C158.977 76.2246 158.836 75.748 158.742 75.1855C158.656 74.6152 158.613 74.0293 158.613 73.4277ZM159.094 68.8691L159.117 70.9785H157.371C157.004 70.9785 156.691 71.0293 156.434 71.1309C156.184 71.2324 155.98 71.373 155.824 71.5527C155.676 71.7246 155.566 71.9199 155.496 72.1387C155.434 72.3574 155.402 72.5879 155.402 72.8301C155.402 73.0645 155.457 73.2754 155.566 73.4629C155.684 73.6426 155.84 73.7832 156.035 73.8848C156.23 73.9863 156.449 74.0371 156.691 74.0371C157.129 74.0371 157.5 73.9551 157.805 73.791C158.117 73.6191 158.355 73.4121 158.52 73.1699C158.684 72.9277 158.766 72.7012 158.766 72.4902L159.633 74.1074C159.477 74.4199 159.297 74.7363 159.094 75.0566C158.898 75.377 158.652 75.6738 158.355 75.9473C158.066 76.2129 157.711 76.4316 157.289 76.6035C156.867 76.7676 156.355 76.8496 155.754 76.8496C154.973 76.8496 154.254 76.6895 153.598 76.3691C152.949 76.0488 152.43 75.6035 152.039 75.0332C151.648 74.4551 151.453 73.791 151.453 73.041C151.453 72.3848 151.57 71.7988 151.805 71.2832C152.047 70.7676 152.41 70.3301 152.895 69.9707C153.379 69.6113 153.996 69.3379 154.746 69.1504C155.496 68.9629 156.379 68.8691 157.395 68.8691H159.094ZM168.762 66.6191V76.6152H164.812V63.9355H168.516L168.762 66.6191ZM168.281 69.8418L167.379 69.8652C167.379 68.9746 167.484 68.1543 167.695 67.4043C167.906 66.6543 168.219 66.002 168.633 65.4473C169.047 64.8926 169.555 64.4629 170.156 64.1582C170.766 63.8535 171.469 63.7012 172.266 63.7012C172.82 63.7012 173.324 63.7871 173.777 63.959C174.23 64.123 174.621 64.3848 174.949 64.7441C175.277 65.0957 175.527 65.5566 175.699 66.127C175.879 66.6895 175.969 67.3652 175.969 68.1543V76.6152H172.02V68.6582C172.02 68.1191 171.957 67.7129 171.832 67.4395C171.715 67.166 171.543 66.9824 171.316 66.8887C171.09 66.7949 170.812 66.748 170.484 66.748C170.141 66.748 169.832 66.8262 169.559 66.9824C169.285 67.1387 169.051 67.3574 168.855 67.6387C168.668 67.9121 168.523 68.2363 168.422 68.6113C168.328 68.9863 168.281 69.3965 168.281 69.8418ZM175.523 69.8418L174.422 69.8652C174.422 68.9746 174.52 68.1543 174.715 67.4043C174.918 66.6543 175.219 66.002 175.617 65.4473C176.023 64.8926 176.527 64.4629 177.129 64.1582C177.73 63.8535 178.43 63.7012 179.227 63.7012C179.805 63.7012 180.336 63.7871 180.82 63.959C181.305 64.1309 181.723 64.4082 182.074 64.791C182.426 65.1738 182.699 65.6816 182.895 66.3145C183.09 66.9395 183.188 67.7129 183.188 68.6348V76.6152H179.227V68.6348C179.227 68.1113 179.164 67.7168 179.039 67.4512C178.922 67.1777 178.75 66.9941 178.523 66.9004C178.297 66.7988 178.027 66.748 177.715 66.748C177.34 66.748 177.016 66.8262 176.742 66.9824C176.469 67.1387 176.238 67.3574 176.051 67.6387C175.871 67.9121 175.738 68.2363 175.652 68.6113C175.566 68.9863 175.523 69.3965 175.523 69.8418ZM189.434 66.373V81.4902H185.484V63.9355H189.164L189.434 66.373ZM197.215 70.123V70.3691C197.215 71.291 197.109 72.1465 196.898 72.9355C196.688 73.7246 196.375 74.4121 195.961 74.998C195.547 75.584 195.031 76.041 194.414 76.3691C193.805 76.6895 193.098 76.8496 192.293 76.8496C191.535 76.8496 190.883 76.6816 190.336 76.3457C189.789 76.0098 189.332 75.5449 188.965 74.9512C188.598 74.3574 188.301 73.6777 188.074 72.9121C187.848 72.1465 187.668 71.3379 187.535 70.4863V70.1699C187.668 69.2559 187.848 68.4082 188.074 67.627C188.301 66.8379 188.598 66.1504 188.965 65.5645C189.332 64.9785 189.785 64.5215 190.324 64.1934C190.871 63.8652 191.523 63.7012 192.281 63.7012C193.086 63.7012 193.793 63.8535 194.402 64.1582C195.02 64.4629 195.535 64.9004 195.949 65.4707C196.371 66.0332 196.688 66.709 196.898 67.498C197.109 68.2871 197.215 69.1621 197.215 70.123ZM193.266 70.3691V70.123C193.266 69.6309 193.23 69.1816 193.16 68.7754C193.09 68.3613 192.977 68.002 192.82 67.6973C192.672 67.3926 192.473 67.1582 192.223 66.9941C191.973 66.8301 191.664 66.748 191.297 66.748C190.875 66.748 190.52 66.8145 190.23 66.9473C189.949 67.0723 189.723 67.2676 189.551 67.5332C189.387 67.791 189.27 68.1152 189.199 68.5059C189.137 68.8887 189.109 69.3379 189.117 69.8535V70.8145C189.102 71.4082 189.16 71.9316 189.293 72.3848C189.426 72.8301 189.656 73.1777 189.984 73.4277C190.312 73.6777 190.758 73.8027 191.32 73.8027C191.695 73.8027 192.008 73.7168 192.258 73.5449C192.508 73.3652 192.707 73.1191 192.855 72.8066C193.004 72.4863 193.109 72.1191 193.172 71.7051C193.234 71.291 193.266 70.8457 193.266 70.3691ZM203.145 63.9355V76.6152H199.184V63.9355H203.145ZM198.949 60.666C198.949 60.1035 199.152 59.6426 199.559 59.2832C199.965 58.9238 200.492 58.7441 201.141 58.7441C201.789 58.7441 202.316 58.9238 202.723 59.2832C203.129 59.6426 203.332 60.1035 203.332 60.666C203.332 61.2285 203.129 61.6895 202.723 62.0488C202.316 62.4082 201.789 62.5879 201.141 62.5879C200.492 62.5879 199.965 62.4082 199.559 62.0488C199.152 61.6895 198.949 61.2285 198.949 60.666ZM205.09 70.4043V70.1582C205.09 69.2285 205.223 68.373 205.488 67.5918C205.754 66.8027 206.145 66.1191 206.66 65.541C207.176 64.9629 207.812 64.5137 208.57 64.1934C209.328 63.8652 210.203 63.7012 211.195 63.7012C212.195 63.7012 213.074 63.8652 213.832 64.1934C214.598 64.5137 215.238 64.9629 215.754 65.541C216.27 66.1191 216.66 66.8027 216.926 67.5918C217.191 68.373 217.324 69.2285 217.324 70.1582V70.4043C217.324 71.3262 217.191 72.1816 216.926 72.9707C216.66 73.752 216.27 74.4355 215.754 75.0215C215.238 75.5996 214.602 76.0488 213.844 76.3691C213.086 76.6895 212.211 76.8496 211.219 76.8496C210.227 76.8496 209.348 76.6895 208.582 76.3691C207.816 76.0488 207.176 75.5996 206.66 75.0215C206.145 74.4355 205.754 73.752 205.488 72.9707C205.223 72.1816 205.09 71.3262 205.09 70.4043ZM209.039 70.1582V70.4043C209.039 70.8809 209.074 71.3262 209.145 71.7402C209.215 72.1543 209.332 72.5176 209.496 72.8301C209.66 73.1348 209.883 73.373 210.164 73.5449C210.445 73.7168 210.797 73.8027 211.219 73.8027C211.633 73.8027 211.977 73.7168 212.25 73.5449C212.531 73.373 212.754 73.1348 212.918 72.8301C213.082 72.5176 213.199 72.1543 213.27 71.7402C213.34 71.3262 213.375 70.8809 213.375 70.4043V70.1582C213.375 69.6973 213.34 69.2637 213.27 68.8574C213.199 68.4434 213.082 68.0801 212.918 67.7676C212.754 67.4473 212.531 67.1973 212.25 67.0176C211.969 66.8379 211.617 66.748 211.195 66.748C210.781 66.748 210.434 66.8379 210.152 67.0176C209.879 67.1973 209.66 67.4473 209.496 67.7676C209.332 68.0801 209.215 68.4434 209.145 68.8574C209.074 69.2637 209.039 69.6973 209.039 70.1582ZM222.961 66.6426V76.6152H219.012V63.9355H222.715L222.961 66.6426ZM222.492 69.8418L221.566 69.8652C221.566 68.8965 221.684 68.0332 221.918 67.2754C222.152 66.5098 222.484 65.8613 222.914 65.3301C223.344 64.7988 223.855 64.3965 224.449 64.123C225.051 63.8418 225.719 63.7012 226.453 63.7012C227.039 63.7012 227.574 63.7871 228.059 63.959C228.551 64.1309 228.973 64.4082 229.324 64.791C229.684 65.1738 229.957 65.6816 230.145 66.3145C230.34 66.9395 230.438 67.7129 230.438 68.6348V76.6152H226.465V68.623C226.465 68.1152 226.395 67.7285 226.254 67.4629C226.113 67.1895 225.91 67.002 225.645 66.9004C225.379 66.7988 225.055 66.748 224.672 66.748C224.266 66.748 223.922 66.8262 223.641 66.9824C223.359 67.1387 223.133 67.3574 222.961 67.6387C222.797 67.9121 222.676 68.2363 222.598 68.6113C222.527 68.9863 222.492 69.3965 222.492 69.8418ZM237.059 59.5527L236.555 71.2129H233.344L232.84 59.5527H237.059ZM232.734 74.8457C232.734 74.2832 232.938 73.8145 233.344 73.4395C233.75 73.0566 234.277 72.8652 234.926 72.8652C235.574 72.8652 236.098 73.0566 236.496 73.4395C236.902 73.8145 237.105 74.2832 237.105 74.8457C237.105 75.4082 236.902 75.8809 236.496 76.2637C236.098 76.6387 235.574 76.8262 234.926 76.8262C234.277 76.8262 233.75 76.6387 233.344 76.2637C232.938 75.8809 232.734 75.4082 232.734 74.8457Z",
    fill: "url(#paint68_linear_5712_87851)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M258.491 53.0985C258.491 53.0985 177.783 46.8478 141.63 48.7883C105.472 50.7301 94.2148 56.3003 94.2148 56.3003C94.4294 54.4806 94.7487 53.1873 95.1605 52.72C100.67 46.4397 259.001 46.4397 264.511 52.72C264.923 53.1934 261.755 53.3586 258.491 53.0973V53.0985Z",
    fill: "url(#paint69_linear_5712_87851)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5712_87851",
    x: -1.10251,
    y: -1.11424,
    width: 362.072,
    height: 127.898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.27538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.34422
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5712_87851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5712_87851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5712_87851",
    x1: 152.985,
    y1: 38.8142,
    x2: 152.985,
    y2: 7.28075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5712_87851",
    x1: 152.985,
    y1: 38.8135,
    x2: 152.985,
    y2: 7.47852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5712_87851",
    x1: 153.896,
    y1: 21.4041,
    x2: 153.896,
    y2: 7.63125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5712_87851",
    x1: 147.107,
    y1: 17.2025,
    x2: 147.107,
    y2: 10.8348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5712_87851",
    x1: 163.011,
    y1: 30.8722,
    x2: 163.011,
    y2: 26.6484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5712_87851",
    x1: 157.326,
    y1: 21.2798,
    x2: 157.326,
    y2: 7.67578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5712_87851",
    x1: 167.392,
    y1: 30.3141,
    x2: 167.392,
    y2: 24.1621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5712_87851",
    x1: 152.959,
    y1: 15.4705,
    x2: 152.959,
    y2: 13.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFFFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5712_87851",
    x1: 164.146,
    y1: 28.2564,
    x2: 164.146,
    y2: 26.2734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFFFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5712_87851",
    x1: 142.18,
    y1: 20.8148,
    x2: 142.18,
    y2: 8.74212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFFFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5712_87851",
    x1: 207.647,
    y1: 38.8158,
    x2: 207.647,
    y2: 7.2824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5712_87851",
    x1: 207.645,
    y1: -8.51946,
    x2: 207.645,
    y2: 7.47852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5712_87851",
    x1: 206.746,
    y1: 21.4041,
    x2: 206.746,
    y2: 7.63125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5712_87851",
    x1: 213.53,
    y1: 17.2025,
    x2: 213.53,
    y2: 10.8348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5712_87851",
    x1: 197.626,
    y1: 30.8722,
    x2: 197.626,
    y2: 26.6484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5712_87851",
    x1: 203.308,
    y1: 21.2798,
    x2: 203.308,
    y2: 7.67578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5712_87851",
    x1: 193.238,
    y1: 30.3141,
    x2: 193.238,
    y2: 24.1621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5712_87851",
    x1: 207.677,
    y1: 15.4705,
    x2: 207.677,
    y2: 13.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFFFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5712_87851",
    x1: 196.49,
    y1: 28.2564,
    x2: 196.49,
    y2: 26.2734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5712_87851",
    x1: 218.861,
    y1: 20.8227,
    x2: 218.861,
    y2: 8.75782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFFFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5712_87851",
    x1: 180.324,
    y1: 44.9984,
    x2: 180.324,
    y2: 5.29727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5712_87851",
    x1: 180.325,
    y1: 43.7721,
    x2: 180.325,
    y2: 5.8336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5712_87851",
    x1: 180.835,
    y1: 37.3266,
    x2: 180.835,
    y2: 31.3496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5712_87851",
    x1: 237.278,
    y1: 66.0002,
    x2: 237.278,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5712_87851",
    x1: 247.047,
    y1: 43.9019,
    x2: 247.047,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5712_87851",
    x1: 247.816,
    y1: 52.7403,
    x2: 253.104,
    y2: 52.7403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5712_87851",
    x1: 248.208,
    y1: 66.0006,
    x2: 248.208,
    y2: 52.3321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_5712_87851",
    x1: 252.523,
    y1: 53.1166,
    x2: 252.523,
    y2: 33.5851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_5712_87851",
    x1: 251.681,
    y1: 55.1297,
    x2: 251.681,
    y2: 52.7717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_5712_87851",
    x1: 241.73,
    y1: 34.6184,
    x2: 255.454,
    y2: 34.6184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_5712_87851",
    x1: 249.656,
    y1: 50.808,
    x2: 255.043,
    y2: 50.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_5712_87851",
    x1: 123.662,
    y1: 66.0006,
    x2: 123.662,
    y2: 12.4414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_5712_87851",
    x1: 113.978,
    y1: 44.0827,
    x2: 113.978,
    y2: 12.4414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_5712_87851",
    x1: 113.213,
    y1: 52.8488,
    x2: 107.969,
    y2: 52.8488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_5712_87851",
    x1: 112.824,
    y1: 66.0003,
    x2: 112.824,
    y2: 52.4434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_5712_87851",
    x1: 108.544,
    y1: 53.2227,
    x2: 108.544,
    y2: 33.8507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_5712_87851",
    x1: 116.291,
    y1: 38.7776,
    x2: 116.291,
    y2: 19.6038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_5712_87851",
    x1: 110.783,
    y1: 50.8308,
    x2: 110.783,
    y2: 36.0614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_5712_87851",
    x1: 109.383,
    y1: 55.2179,
    x2: 109.383,
    y2: 52.8791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_5712_87851",
    x1: 119.248,
    y1: 34.8756,
    x2: 105.637,
    y2: 34.8756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_5712_87851",
    x1: 111.389,
    y1: 50.9303,
    x2: 106.047,
    y2: 50.9303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A25C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D144FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_5712_87851",
    x1: 322.765,
    y1: 111.818,
    x2: 322.765,
    y2: 70.8418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_5712_87851",
    x1: 249.556,
    y1: 77.588,
    x2: 249.556,
    y2: 45.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_5712_87851",
    x1: 255.748,
    y1: 75.6542,
    x2: 247.218,
    y2: 60.8817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C581DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_5712_87851",
    x1: 305.229,
    y1: 83.5415,
    x2: 305.229,
    y2: 53.2767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB2903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C13F16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_5712_87851",
    x1: 283.032,
    y1: 71.897,
    x2: 283.032,
    y2: 43.1889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFF34A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_5712_87851",
    x1: 209.172,
    y1: -33.5586,
    x2: 336.506,
    y2: -33.5586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B73614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB6B16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_5712_87851",
    x1: 328.383,
    y1: 78.3535,
    x2: 350.283,
    y2: 78.3535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1208"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_5712_87851",
    x1: 282.988,
    y1: 36.3742,
    x2: 292.12,
    y2: 40.7633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_5712_87851",
    x1: 309.102,
    y1: 67.848,
    x2: 309.102,
    y2: 61.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978DDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_5712_87851",
    x1: 283.032,
    y1: 64.9597,
    x2: 283.032,
    y2: 60.2143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978DDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_5712_87851",
    x1: 305.477,
    y1: 79.8423,
    x2: 305.477,
    y2: 65.8379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_5712_87851",
    x1: 283.079,
    y1: 70.4024,
    x2: 283.079,
    y2: 61.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_5712_87851",
    x1: 325.765,
    y1: 84.6694,
    x2: 335.468,
    y2: 100.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_5712_87851",
    x1: 37.0968,
    y1: 111.818,
    x2: 37.0968,
    y2: 70.8418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_5712_87851",
    x1: 110.302,
    y1: 77.5892,
    x2: 110.302,
    y2: 45.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_5712_87851",
    x1: 104.12,
    y1: 75.6542,
    x2: 112.649,
    y2: 60.8817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C581DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_5712_87851",
    x1: 54.6387,
    y1: 83.5415,
    x2: 54.6387,
    y2: 53.2767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB2903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C13F16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_5712_87851",
    x1: 76.8324,
    y1: 71.897,
    x2: 76.8324,
    y2: 43.1889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFF34A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_5712_87851",
    x1: 23.3672,
    y1: -33.5586,
    x2: 150.7,
    y2: -33.5586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF3F16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B73614"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_5712_87851",
    x1: 9.5866,
    y1: 78.3535,
    x2: 31.4859,
    y2: 78.3535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1208"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_5712_87851",
    x1: 76.6513,
    y1: 36.3742,
    x2: 85.7833,
    y2: 40.7626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_5712_87851",
    x1: 50.7612,
    y1: 67.848,
    x2: 50.7612,
    y2: 61.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978DDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_5712_87851",
    x1: 76.8315,
    y1: 64.9597,
    x2: 76.8315,
    y2: 60.2143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978DDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_5712_87851",
    x1: 54.3871,
    y1: 79.8423,
    x2: 54.3871,
    y2: 65.8379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_5712_87851",
    x1: 76.7898,
    y1: 70.4024,
    x2: 76.7898,
    y2: 61.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_5712_87851",
    x1: 33.3905,
    y1: 84.6694,
    x2: 43.0928,
    y2: 100.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_5712_87851",
    x1: 128.053,
    y1: 66.1629,
    x2: 230.936,
    y2: 66.1629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1208"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_5712_87851",
    x1: 179.884,
    y1: 52.6154,
    x2: 179.884,
    y2: 84.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCA1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_5712_87851",
    x1: 94.22,
    y1: 37.4536,
    x2: 264.558,
    y2: 37.4536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1208"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5712_87851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 125,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampion);
export default __webpack_public_path__ + "static/media/champion.a8d15a80cff9feaed8b9ed28028760c5.svg";
export { ForwardRef as ReactComponent };